"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLocale = void 0;
if (process.env.REACT_APP_DEFAULT_LOCALE === undefined) {
    throw new Error('REACT_APP_DEFAULT_LOCALE must be defined in .env file!');
}
exports.defaultLocale = process.env.REACT_APP_DEFAULT_LOCALE;
